<template>
  <el-result
    icon="error"
    title="404"
  >
    <template #extra>
      <el-button type="primary" size="medium" @click="$router.push('/')">{{ $t('go-back') }}</el-button>
    </template>
  </el-result>
</template>